import { MapPin } from "lucide-react";
import footerBg from "@/assets/footer-bg.jpg";

export function Schedule() {
  return (
    <div className="min-h-screen bg-background">
      <article className="pt-24 md:pt-32 pb-20 mx-auto px-6 max-w-175">
        <h1 className="font-display text-4xl text-foreground text-center mb-12">
          Schedule
        </h1>

        <div className="space-y-16">
          <div className="text-center">
            <h2 className="font-display text-xl md:text-2xl text-foreground mb-3">
              Welcome Drinks
            </h2>
            <p className="font-body text-muted-foreground mb-3">
              Thursday, August 27 | 5:30–9:00 PM
            </p>
            <a
              href="https://share.google/U75Zlg3MGFaqVAnAg"
              target="_blank"
              rel="noopener noreferrer"
              className="font-body text-primary underline underline-offset-4 hover:text-primary/80 transition-colors inline-flex items-center gap-1"
            >
              <MapPin className="w-4 h-4" />
              Ferment Brewing Company
            </a>
            <div className="mt-6 space-y-2">
              <p className="font-body text-muted-foreground leading-relaxed">
                Pop in and out as you please. We'll have a tab open - come say hi!
              </p>
              <p className="font-body text-muted-foreground leading-relaxed">
                Ferment also has food available if you'd like to grab dinner. We'll be eating here too.
              </p>
            </div>
          </div>

          <div className="text-center">
            <h2 className="font-display text-xl md:text-2xl text-foreground mb-3">
              Ceremony & Reception
            </h2>
            <p className="font-body text-muted-foreground mb-3">
              Friday, August 28 | 3:00–9:30 PM
            </p>
            <a
              href="https://share.google/KFumjrOuiikBYa8Rr"
              target="_blank"
              rel="noopener noreferrer"
              className="font-body text-primary underline underline-offset-4 hover:text-primary/80 transition-colors inline-flex items-center gap-1"
            >
              <MapPin className="w-4 h-4" />
              The Orchard
            </a>
            <div className="mt-6 space-y-2">
              <p className="font-body text-muted-foreground">3:00 PM – Guests arrive</p>
              <p className="font-body text-muted-foreground">4:00 PM – Ceremony</p>
              <p className="font-body text-muted-foreground">5:45 PM – Dinner & Reception</p>
            </div>
          </div>
        </div>
      </article>

      <img src={footerBg} alt="" className="w-full" />
    </div>
  );
}
